<div class="customer-inspection">
  <div class="content">
    <div class="ui-g-7" [ngClass]="{ estimate: customerInspections && customerInspections.length > 0, 'no-estimate': customerInspections && customerInspections.length === 0 }">
      <div *ngIf="customerInspections.length > 0" class="inspection-section">
        <div
          *ngFor="let insp of customerInspections; let i = index"
          id="link-open-inspections-{{ i }}"
          class="ui-g-12 inspection-card pointer"
          [ngClass]="{ 'mb-2': customerInspections && i < customerInspections.length - 1, 'mb-5': customerInspections && i === customerInspections.length - 1 }"
          (click)="preview(insp)"
        >
          <div class="ui-g-3 text-center">
            <div class="inspection-month">
              <p class="mb-0">{{ insp.dateTime | date: 'MMM' }}</p>
            </div>

            <div class="inspection-date">
              <span>{{ insp.dateTime | date: 'dd' }}</span>
            </div>

            <div class="inspection-time">
              <span class="font-600">
                {{ insp.dateTime | date: 'hh:mm aa' }}
              </span>
            </div>

            <div *ngIf="isMultiLocationEnabled && insp?.shopId" class="location-pill">
              <span class="location-bg" [ngStyle]="{ backgroundColor: shopsMap[insp?.shopId]?.shopColor }"></span>
              <p class="location-name" [ngStyle]="{ color: shopsMap[insp?.shopId]?.shopColor }">
                <i class="fal fa-store-alt"></i>
                {{ shopsMap[insp?.shopId]?.shopName }}
              </p>
            </div>
          </div>

          <div class="ui-g-9 pl-1">
            <div class="ui-g-12 p-zero">
              <span class="font-600 font-14 inspection-name">{{ insp?.inspection?.title }}</span>
            </div>

            <div class="ui-g-12 p-zero">
              <span class="font-11 inspection-estimate-name">
                <i class="fal fa-file-alt"></i>
                <p class="estimate-name-text">{{ insp.estimate?.title || 'Untitled' }}</p>
              </span>
            </div>

            <div class="ui-g-12 p-zero">
              <span class="font-11 inspection-details">
                <i class="fal fa-car"></i>
                <p class="estimate-details">{{ insp?.estimate?.vehicle?.name || 'Untitled' }}</p>
              </span>
            </div>

            <div class="ui-g-12 count-list pb-0">
              <ul class="inspection-status d-flex mb-0">
                <li class="d-flex">
                  <div class="circle green"></div>
                  <span class="font-10 pl-1">
                    {{ insp.category ? insp?.condition?.condition?.good : 0 }}
                  </span>
                </li>

                <li class="d-flex">
                  <div class="circle yellow"></div>
                  <span class="font-10 pl-1">
                    {{ insp.category ? insp?.condition?.condition?.normal : 0 }}
                  </span>
                </li>

                <li class="d-flex">
                  <div class="circle red"></div>
                  <span class="font-10 pl-1">
                    {{ insp.category ? insp?.condition?.condition?.bad : 0 }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div id="inspections-btn-show-all" *ngIf="customerInspections.length > 1" class="show-more text-center" (click)="showAll()">
          <p>show more</p>
        </div>
      </div>

      <div class="ui-g-12 text-center mt-2" *ngIf="customerInspections.length === 0">
        <p class="font-13">There is no inspection yet</p>
      </div>
    </div>

    <div class="ui-g-5 appointment-section">
      <app-upcoming-appointment [isLoadingAppointment]="isLoadingAppointment" [vehicles]="vehicles" [appointments]="customerAppointments" [user]="customer" [tab]="'inspection tab'">
      </app-upcoming-appointment>
    </div>
  </div>
</div>
